import enLang from './entries/enLang';
import thLang from './entries/thLang';
import { addLocaleData } from 'react-intl';

const options = [
  {
    locale: 'th',
    lang: thLang
  },
  {
    locale: 'en',
    lang: enLang
  }
];

function getCurrentLanguage(lang = 'th') {
  let selecetedLanguage = options[0];
  options.forEach((language) => {
    addLocaleData(language.lang.data);
    if (language.locale === lang) {
      selecetedLanguage = language;
    }
  });
  return selecetedLanguage;
}

export default getCurrentLanguage;
